import { handleResponse, handleError } from "./apiUtils";
const baseUrl = process.env.REACT_APP_API_SERVER_URL + "/api/profile";

export function getReports(accessToken) {
  return fetch(baseUrl + "/reports", {
    headers: {
      Authorization: "Bearer " + accessToken
    }
  })
    .then(handleResponse)
    .catch(handleError);
}

export function passProfileOrEvent(accessToken, body) {
  console.log(body);
  return fetch(baseUrl + "/pass?id=" + body.id, {
    method: "PUT",
    headers: {
      "content-type": "application/json",
      Authorization: "Bearer " + accessToken
    },
    body: JSON.stringify(body)
  })
    .then(handleResponse)
    .catch(handleError);
}

export function failProfile(accessToken, body) {
  console.log(body);
  return fetch(baseUrl + "/failProfile?id=" + body.id, {
    method: "PUT",
    headers: {
      "content-type": "application/json",
      Authorization: "Bearer " + accessToken
    },
    body: JSON.stringify(body)
  })
    .then(handleResponse)
    .catch(handleError);
}

export function failEvent(accessToken, body) {
  return fetch(baseUrl + "/failEvent?id=" + body.id, {
    method: "PUT",
    headers: {
      "content-type": "application/json",
      Authorization: "Bearer " + accessToken
    },
    body: JSON.stringify(body)
  })
    .then(handleResponse)
    .catch(handleError);
}

export function getReportsByUser(accessToken) {
  return fetch(baseUrl + "/reportsByUser", {
    headers: {
      Authorization: "Bearer " + accessToken
    }
  })
    .then(handleResponse)
    .catch(handleError);
}
